import React, { useEffect, useMemo, useState } from 'react';
import '../../css/modal.css';
import { fetchPackages } from '../../api/Packages';

type Props = {
  queryId: number;
  onClose: () => void;
  onCreateFromScratch: () => void;
  onUsePackage: (pkg: any) => void;
};

const StartQuotationModal: React.FC<Props> = ({ queryId, onClose, onCreateFromScratch, onUsePackage }) => {
  const [loading, setLoading] = useState(false);
  const [packages, setPackages] = useState<any[]>([]);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState<any | null>(null);

  useEffect(() => {
    setLoading(true);
    fetchPackages().then((ps:any[]) => setPackages(Array.isArray(ps)? ps: [])).catch(()=> setPackages([])).finally(()=> setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    const term = search.toLowerCase();
    return packages.filter((p:any)=> {
      const title = (p.title||'').toLowerCase();
      const cities = Array.isArray(p.cities) ? p.cities.join(', ').toLowerCase() : '';
      return title.includes(term) || cities.includes(term);
    });
  }, [packages, search]);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal modal-lg" onClick={e=>e.stopPropagation()}>
        <div className="modal-header">
          <h2>Start Quotation</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <label>Search Packages</label>
          <input value={search} onChange={e=> setSearch(e.target.value)} placeholder="Search by title or city" />
          <div className="package-list">
            {loading ? (
              <div className="package-empty">Loading…</div>
            ) : filtered.length === 0 ? (
              <div className="package-empty">No packages found</div>
            ) : (
              filtered.map((p:any)=> {
                const cities = Array.isArray(p.cities) ? p.cities : [];
                const nights = Number(p.duration_nights || p.durationNights || 0);
                const hotelsCount = Array.isArray(p.hotels) ? p.hotels.length : 0;
                const inc: string[] = Array.isArray(p.inclusions) ? p.inclusions : [];
                const hasFlights = inc.includes('flight') || (Array.isArray((p as any).flights) && (p as any).flights.length>0);
                const hasHotels = inc.includes('hotel') || hotelsCount > 0;
                const hasActivities = inc.includes('activity');
                const hasTransfers = inc.includes('transfer');
                const isSelected = !!selected && ((selected.id && selected.id===p.id) || (selected.slug && selected.slug===p.slug));
                return (
                  <div 
                    key={p.id || p.slug}
                    className={`package-item ${isSelected ? 'selected' : ''}`}
                    onClick={()=> setSelected(p)}
                  >
                    <div className="package-title">{p.title}</div>
                    <div className="package-meta">
                      <span>{cities.join(' · ')}</span>
                      <span>• {nights}N</span>
                    </div>
                    <div className="package-stats">
                      <span className={`package-stat ${hasFlights ? 'on' : ''}`}>Flights</span>
                      <span className={`package-stat ${hasHotels ? 'on' : ''}`}>Hotels{hotelsCount ? ` (${hotelsCount})` : ''}</span>
                      <span className={`package-stat ${hasActivities ? 'on' : ''}`}>Activities</span>
                      <span className={`package-stat ${hasTransfers ? 'on' : ''}`}>Transfers</span>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div className="modal-actions">
          <button onClick={onCreateFromScratch}>Create From Scratch</button>
          <button className="secondary" onClick={()=> selected ? onUsePackage(selected): null} disabled={!selected}>Use Selected</button>
        </div>
      </div>
    </div>
  );
};

export default StartQuotationModal;
